module.exports = "//static.hsappstatic.net/ecosystem-marketplace-apps-base/static-1.3109/img/video-thumb-overlay.png"